import { Link } from 'react-router-dom'
import { Layout } from '../components/Layout'

export function NotFound() {
  return (
    <Layout section="home">
      <section className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="grid grid-cols-12 gap-4 py-32">
          <div className="col-span-12 md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[color:var(--color-muted)]">
              404
            </p>
          </div>

          <div className="col-span-12 md:col-span-10">
            <h1 className="font-[var(--font-display)] text-7xl font-medium leading-[0.9] tracking-tight md:text-9xl">
              <span className="block">nothing</span>
              <span className="block text-[color:var(--color-fg)]/40">to see</span>
              <span className="block italic">here</span>
            </h1>

            <Link
              to="/"
              data-cursor="hover"
              className="mt-12 inline-block font-mono text-xs uppercase tracking-[0.2em] underline decoration-1 underline-offset-4"
            >
              ← back home
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  )
}
